<template>
  <div class="contenedor p-0">
    <h4>Booker Stats</h4>
    <div
      class="d-flex align-items-center justify-content-center w-100"
      v-if="loading"
    >
      <LoadingSpinner></LoadingSpinner>
    </div>
    <div v-else class="mx-0 pb-5">
      <!-- Filter Section -->
      <div class="w-25">
          <Tabs 
            :tabSelected="tabSelected" 
            :tabs="tabs" 
            @change="changeTab($event)" 
            class="mx-3"
          />
      </div>

      <div class="col-12 px-0">
        <div class="container-fluid w-100 mb-3 p-0 border bg-white rounded stats-wrapper">
          <div class="d-flex flex-wrap">
            <!-- RECRUITER FILTER -->
            <div class="w-25 input-group input-group-sm p-1 treeselect-wrapper">
              <div class="input-group-prepend">
                <span class="input-group-text" id="inputGroup-sizing-sm">Recruiter</span>
              </div>
              <treeselect v-model="filters.recruiterFilter" :options="recruiterOptions"
                :loading="recruitersLoading" placeholder="Loading recruiters..." class="form-control inline-table">
              </treeselect>
            </div>

            <!-- COUNTRY FILTER -->
            <div class="w-25 input-group input-group-sm p-1 treeselect-wrapper">
              <div class="input-group-prepend">
                <span class="input-group-text" id="inputGroup-sizing-sm">Country</span>
              </div>
              <treeselect v-model="filters.countryFilter" :options="countryOptions"
                :loading="countriesLoading" placeholder="Loading countries..." class="form-control inline-table">
              </treeselect>
            </div>

            <!-- ORIGIN FILTER -->
            <div class="w-25 input-group input-group-sm p-1 treeselect-wrapper">
              <div class="input-group-prepend">
                <span class="input-group-text" id="inputGroup-sizing-sm">How did you meet us</span>
              </div>
              <treeselect v-model="filters.originFilter" :options="originOptions"
                placeholder="Select origins..." class="form-control inline-table">
              </treeselect>
            </div>

            <!-- YEAR FILTER -->
            <div v-if="tabSelected == 1 || tabSelected == 2 || tabSelected == 4" class="w-25 input-group input-group-sm p-1 treeselect-wrapper">
              <div class="input-group-prepend">
                <span class="input-group-text" id="inputGroup-sizing-sm">Year</span>
              </div>
              <treeselect v-model="filters.yearFilter" :options="yearOptions"
                placeholder="Select year..." class="form-control inline-table">
              </treeselect>
            </div>

            <!-- BOOKER TYPE FILTER -->
            <div v-if="tabSelected == 1 || tabSelected == 2 || tabSelected == 4" class="w-25 input-group input-group-sm p-1 treeselect-wrapper">
              <div class="input-group-prepend">
                <span class="input-group-text" id="inputGroup-sizing-sm">Booker Type</span>
              </div>
              <select class="form-control" v-model="filters.booker_type">
                <option value="all">All Types</option>
                <option value="human">Human</option>
                <option value="ai_agent">Agent AI</option>
              </select>
            </div>

            <!-- FILTER BUTTON -->
            <div class="w-25 p-1 ml-auto">
              <div class="col-md-12 d-flex justify-content-end my-2">
                <button class="btn btn-success" :disabled="loading" @click="applyFilters()">
                  <i class="icon-calendar-check-o mr-2"></i>
                  <small>Apply Filters</small>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-if="tabSelected != 3" class="col-12 px-0 mb-3">
        <button class="btn btn-primary themed-button mr-2" @click="applyFilters('days')">Day</button>
        <button class="btn btn-primary themed-button mr-2" @click="applyFilters('weeks')">Week</button>
        <button class="btn btn-primary themed-button" @click="applyFilters('months')">Month</button>
      </div>

      <!-- Recruitments tab: Pipe Stats, Turnover, Onboarding time, Validated time -->
      <div v-show="tabSelected === 1" class="recruitments-tab">
        <div class="row">
          <div class="col-sm-12 mt-2">
            <h5 class="ml-3">Pipe Stats</h5>
            <div class="table-responsive">           
              <StatsTable
                :statsClient="statsClient"
                :statsType="statsType"
                :statsDate="statsDate"
                :showTotal="false"
                :compactCells="true"
              />            
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-sm-12">          
            <h5 class="ml-3">Turnover</h5>
            <div class="table-responsive m-0">
              <StatsTable
                :statsClient="statsClientTask"
                :statsType="statsTypeTask"
                :statsDate="statsDateTask"
                :showTotal="false"
                :compactCells="true"
              />
            </div>              
          </div>
        </div>

        <div class="row">
          <div class="col-sm-12">
            <h5 class="ml-3">Onboarding time</h5>
            <div class="table-responsive">            
              <StatsTable
                :statsClient="statsClientOnboarding"
                :statsType="statsTypeOnboarding"
                :statsDate="statsDateOnboarding"
                :showTotal="false"
              />            
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-sm-12">
            <h5 class="ml-3">Validated time</h5>
            <div class="table-responsive">            
              <StatsTable
                :statsClient="statsClientValidated"
                :statsType="statsTypeValidated"
                :statsDate="statsDateValidated"
                :showTotal="false"
              />
            </div>
          </div>
        </div>
      </div>

      <!-- Performances tab: Cold Tasks Stats, Warm Tasks Stats, Meeting Attendance, Fake meetings -->
      <div v-show="tabSelected === 2" class="recruitments-tab">
        <div class="row">
          <div class="col-sm-12 mt-2">
            <h5 class="ml-3">Cold Tasks Stats</h5>
            <div class="table-responsive">            
              <StatsTable
                :statsClient="statsClientColdTasksBookers"
                :statsType="statsTypeColdTasksBookers"
                :statsDate="statsDateColdTasksBookers"
                :showTotal="false"
                :compactCells="true"
              />               
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-sm-12 mt-2">
            <h5 class="ml-3">Warm Tasks Stats</h5>
            <div class="table-responsive">
              <StatsTable
                :statsClient="statsClientWarmTasksBookers"
                :statsType="statsTypeWarmTasksBookers"
                :statsDate="statsDateWarmTasksBookers"
                :showTotal="false"
                :compactCells="true"
              />
            </div>
          </div>
        </div>
      
        <div class="row">
          <div class="col-sm-12 mt-2">
            <h5 class="ml-3">Meeting Attendance</h5>
            <div class="table-responsive">
              <StatsTable
                :statsClient="statsClientMeetingAttendance"
                :statsType="statsTypeMeetingAttendance"
                :statsDate="statsDateMeetingAttendance"
                :showTotal="false"
              />
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-sm-12 mt-2">
            <h5 class="ml-3">Fake meetings</h5>
            <div class="table-responsive">
              <StatsTable
                :statsClient="statsClientFakeMeeting"
                :statsType="statsTypeFakeMeeting"
                :statsDate="statsDateFakeMeeting"
                :showTotal="false"
              />
            </div>
          </div>
        </div>
      </div>

      <!-- Costs tab: Booker Managers Payments, Booker Cold Callers Payments -->
      <div v-show="tabSelected === 3">
        <div class="row">
          <div class="col-sm-12 mt-5">
            <h5 class="ml-3">Booker Managers Payments</h5>
            <div>
              <StatsTable
                :statsClient="statsClientBookerManagerPayments"
                :statsType="statsTypeBookerManagerPayments"
                :statsDate="statsDateBookerManagerPayments"
                :showTotal="false"
              />
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-sm-12 mt-5">
            <h5 class="ml-3">Booker Cold Callers Payments</h5>
            <div>
              <StatsTable
                :statsClient="statsClientBookerColdCallersPayments"
                :statsType="statsTypeBookerColdCallersPayments"
                :statsDate="statsDateBookerColdCallersPayments"
                :showTotal="false"
              />
            </div>
          </div>
        </div>
      </div>

      <!-- Task output tab: AI email answers analysis, Booker calls output, AI objections analysis -->
      <div v-show="tabSelected == 4">
        <div class="row">
          <div class="col-sm-12 mt-5">
            <h5 class="ml-3">AI email answers analysis</h5>
            <div class="table-responsive">
              <StatsTable
                :statsClient="statsClientAiEmailAnswersAnalysis"
                :statsType="statsTypeAiEmailAnswersAnalysis"
                :statsDate="statsDateAiEmailAnswersAnalysis"
                :showTotal="false"
                :compactCells="true"
              />
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-sm-12 mt-5">
            <h5 class="ml-3">Booker calls output</h5>
            <div class="table-responsive">
              <StatsTable
                :statsClient="statsClientBookerCallsOutput"
                :statsType="statsTypeBookerCallsOutput"
                :statsDate="statsDateBookerCallsOutput"
                :showTotal="false"
                :compactCells="true"
              />
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-sm-12 mt-5">
            <h5 class="ml-3">AI objections analysis</h5>
            <div class="table-responsive">
              <StatsTable
                :statsClient="statsClientAiObjectionsAnalysis"
                :statsType="statsTypeAiObjectionsAnalysis"
                :statsDate="statsDateAiObjectionsAnalysis"
                :showTotal="false"
                :compactCells="true"
              />
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import { bookersService, usersService } from "@/_services";
import StatsTable from "@/components/Usages/StatsTable.vue";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import Tabs from "@/components/Common/Tabs.vue";
export default {
  components: {
    LoadingSpinner,
    StatsTable,
    Treeselect,
    Tabs,
  },
  computed: {
    yearOptions() {
      return (this.years || []).map(y => ({ id: y.id, label: y.text }));
    },
  },
  data() {
    return {
      loading: true,
      loading2: true,
      step_previous: null,
      statsClient: {},
      statsClientTask: {},
      statsClientOnboarding: {},
      statsClientValidated: {},
      statsClientColdTasksBookers: {},
      statsClientWarmTasksBookers: {},      
      statsClientMeetingAttendance: {},
      statsClientFakeMeeting: {},
      statsClientBookerManagerPayments: {},
      statsClientBookerColdCallersPayments: {},
      statsClientAiEmailAnswersAnalysis: {},
      statsClientBookerCallsOutput: {},
      statsClientAiObjectionsAnalysis: {},
      recruiterOptions: [],
      recruitersLoading: false,
      countryOptions: [],
      countriesLoading: false,
      tabSelected: 1,
      periodMetrics: null,
      tabs: {
        1: {
          id: 1,
          name: "Recruitments",
        },
        2: {
          id: 2,
          name: "Performances",
        },
        3: {
          id: 3,
          name: "Costs",
        },
        4: {
          id: 4,
          name: "Task outputs",
        }
      },
      origin: [
        { id: 1, text: 'lang.label.recommendation' },
        { id: 2, text: 'lang.label.facebook' },
        { id: 3, text: 'lang.label.linkedin' },
        { id: 4, text: 'lang.label.universite_catholique_madagascar' },
        { id: 5, text: 'lang.label.project_pair' },
        { id: 6, text: 'lang.label.other' }
      ],
      originOptions: [],
      years: [
        { id: 2022, text: '2022' },
        { id: 2023, text: '2023' },
        { id: 2024, text: '2024' },
        { id: 2025, text: '2025' },
        { id: 2026, text: '2026' },
      ],
      yearOptions: [],
      filters: {
        recruiterFilter: null,
        countryFilter: null,
        originFilter: null,
        yearFilter: null,
        typeTable:null,
        booker_type: 'all',
      },
      statsType: [
        {
          id: "account_created",
          label: "Account Created",
          format: "qty",
          showQty: false,
          showTotal: false,
        },
        {
          id: "interviewed",
          label: "Interviewed",
          format: "qty",
          showQty: true,
          showTotal: false,
        },
        {
          id: "selected",
          label: "Selected",
          format: "qty",
          showQty: true,
          showTotal: false,
        },
        {
          id: "booker",
          label: "Booker",
          format: "qty",
          showQty: true,
          showTotal: false,
        },
        {
          id: "stopped",
          label: "Stopped",
          format: "qty",
          showQty: true,
          showTotal: false,
        },
      ],
      statsTypeTask: [
        {
          id: "tasks",
          label: "Tasks",
          format: "qty",
          showQty: false,
          showTotal: false,
        },
        {
          id: "booker_stopped",
          label: "Booker stopped",
          format: "qty",
          showQty: true,
          showTotal: false,
        },
        
        
      ],
      statsTypeOnboarding: [
        {
          id: "days",
          label: "Days",
          format: "qty",
          showQty: true,
          showTotal: false,
        },        
      ],

      statsTypeValidated: [
        {
          id: "days",
          label: "Days",
          format: "qty",
          showQty: true,
          showTotal: false,
        },        
      ],

      statsTypeColdTasksBookers: [
        {
          id: "bookers",
          label: "Bookers",
          format: "qty",
          showQty: false,
          showTotal: false,
        },
        {
          id: "tasks",
          label: "Tasks",
          format: "qty",
          showQty: false,
          showTotal: false,
        },
        {
          id: "meetings",
          label: "Meetings",
          format: "qty",
          showQty: false,
          showTotal: false,
        },
        {
          id: "conversion_rate",
          label: "Conversion Rate",
          format: "rate",
          showQty: false,
          showTotal: true,
        },        
      ],

      statsTypeWarmTasksBookers: [
        {
          id: "bookers",
          label: "Bookers",
          format: "qty",
          showQty: false,
          showTotal: false,
        },
        {
          id: "tasks",
          label: "Tasks",
          format: "qty",
          showQty: false,
          showTotal: false,
        },
        {
          id: "meetings",
          label: "Meetings",
          format: "qty",
          showQty: false,
          showTotal: false,
        },
        {
          id: "conversion_rate",
          label: "Conversion Rate",
          format: "rate",
          showQty: false,
          showTotal: true,
        },        
      ],

      statsTypeMeetingAttendance: [
        {
          id: "rate_meeting_valid", 
          label: "Valids",
          format: "rate",
          showQty: false,
          showTotal: false,
        },
        {
          id: "total_cancelled_meeting", 
          label: "Cancelled",
          format: "rate",
          showQty: false,
          showTotal: false,
        },
        {
          id: "total_unable_to_reach", 
          label: "Absent",
          format: "rate",
          showQty: false,
          showTotal: false,
        },
               
      ],

      statsTypeFakeMeeting: [
        {
          id: "total_fake", 
          label: "Fake Meetings",
          format: "rate",
          showQty: false,
          showTotal: false,
        },       
               
      ],

      statsTypeBookerManagerPayments: [
        {
          id: "total_managers",
          label: "Total Managers",
          format: "qty",
          showQty: false,
          showTotal: false,
        },
        {
          id: "total_meetings",
          label: "Total Meetings",
          format: "qty",
          showQty: false,
          showTotal: false,
        },
        {
          id: "total_fixed_salary",
          label: "Total Fixed Salary",
          format: "qty",
          showQty: false,
          showTotal: false,
        },
        {
          id: "avg_fixed_salary",
          label: "Avg Fixed Salary",
          format: "qty",
          showQty: false,
          showTotal: false,
        },
        {
          id: "total_variable_salary",
          label: "Total Variable Salary",
          format: "qty",
          showQty: false,
          showTotal: false,
        },
        {
          id: "avg_total_variable_salary",
          label: "Avg Variable Salary",
          format: "qty",
          showQty: false,
          showTotal: false,
        },
      ],

      statsTypeBookerColdCallersPayments: [
        {
          id: "total_managers",
          label: "Total Managers",
          format: "qty",
          showQty: false,
          showTotal: false,
        },
        {
          id: "total_meetings",
          label: "Total Meetings",
          format: "qty",
          showQty: false,
          showTotal: false,
        },
        {
          id: "total_fixed_salary",
          label: "Total Fixed Salary",
          format: "qty",
          showQty: false,
          showTotal: false,
        },
        {
          id: "avg_fixed_salary",
          label: "Avg Fixed Salary",
          format: "qty",
          showQty: false,
          showTotal: false,
        },
        {
          id: "total_variable_salary",
          label: "Total Variable Salary",
          format: "qty",
          showQty: false,
          showTotal: false,
        },
        {
          id: "avg_total_variable_salary",
          label: "Avg Variable Salary",
          format: "qty",
          showQty: false,
          showTotal: false,
        },
      ],

      statsTypeAiEmailAnswersAnalysis: [
        {
          id: "positive",
          label: "Positif",
          format: "qty",
          showQty: true,
          showTotal: false,
        },
        {
          id: "introduction",
          label: "Mise en relation",
          format: "qty",
          showQty: true,
          showTotal: false,
        },
        {
          id: "negative",
          label: "Pas intéressé",
          format: "qty",
          showQty: true,
          showTotal: false,
        },
        {
          id: "not_scope",
          label: "Hors cible",
          format: "qty",
          showQty: true,
          showTotal: false,
        },
        {
          id: "wrong",
          label: "Mauvaise personne",
          format: "qty",
          showQty: true,
          showTotal: false,
        },
        {
          id: "do_not_contact",
          label: "Ne plus contacter",
          format: "qty",
          showQty: true,
          showTotal: false,
        },
        {
          id: "unknown",
          label: "Hors suivi",
          format: "qty",
          showQty: true,
          showTotal: false,
        },
      ],

      statsTypeBookerCallsOutput:[
        {
          id: "no_answered",
          label: "No Answered",
          format: "qty",
          showQty: true,
          showTotal: false,
        },
        {
          id: "call_back",
          label: "Call Back",
          format: "qty",
          showQty: true,
          showTotal: false,
        },
        {
          id: "no_phone",
          label: "No Phone",
          format: "qty",
          showQty: true,
          showTotal: false,
        },
        {
          id: "neutral",
          label: "Neutral",
          format: "qty",
          showQty: true,
          showTotal: false,
        },
        {
          id: "out_of_scope_contact",
          label: "Out of Scope Contact",
          format: "qty",
          showQty: true,
          showTotal: false,
        },
        {
          id: "out_of_scope_company",
          label: "Out of Scope Company",
          format: "qty",
          showQty: true,
          showTotal: false,
        },
        {
          id: "bad_number",
          label: "Bad Number",
          format: "qty",
          showQty: true,
          showTotal: false,
        },
        {
          id: "not_interest",
          label: "Not Interest",
          format: "qty",
          showQty: true,
          showTotal: false,
        },
      ],

      statsTypeAiObjectionsAnalysis:[
        {
          id: "no_need",
          label: "No Need",
          format: "qty",
          showQty: true,
          showTotal: false,
        },
        {
          id: "empty",
          label: "Empty",
          format: "qty",
          showQty: true,
          showTotal: false,
        },
        {
          id: "not_right_person",
          label: "Not Right Person",
          format: "qty",
          showQty: true,
          showTotal: false,
        },
        {
          id: "other",
          label: "Other",
          format: "qty",
          showQty: true,
          showTotal: false,
        },
        {
          id: "not_moment",
          label: "Not Moment",
          format: "qty",
          showQty: true,
          showTotal: false,
        },
        {
          id: "no_pitch",
          label: "No Pitch",
          format: "qty",
          showQty: true,
          showTotal: false,
        },
        {
          id: "already_with_competitor",
          label: "Already Competitor",
          format: "qty",
          showQty: true,
          showTotal: false,
        },
      ],

      statsDate: [],
      statsDateTask: [],
      statsDateOnboarding: [],
      statsDateValidated: [],
      statsDateColdTasksBookers: [],
      statsDateWarmTasksBookers: [],
      statsDateMeetingAttendance: [],
      statsDateBookerManagerPayments: [],
      statsDateBookerColdCallersPayments: [],
      statsDateAiEmailAnswersAnalysis: [],
      statsDateBookerCallsOutput: [],
      statsDateAiObjectionsAnalysis: [],
    };
  },
  created() {
    this.getCountries();
    this.getRecruiters();
    this.originOptions = this.origin.map(o => ({id: o.id, label: this.$t(o.text)}));
    this.yearOptions = this.years.map(y => ({id: y.id, label: y.text}));
    this.tabSelected = 1;
    this.applyFilters();
  },
  methods: {
    initData(){
      this.filters.yearFilter = new Date().getFullYear();
      this.filters.recruiterFilter = null;
      this.filters.countryFilter = null;
      this.filters.originFilter = null;
      this.filters.booker_type = 'all';
    },
    changeTab(tabId) {
      if (tabId === this.tabSelected) return;
      this.initData();
      this.tabSelected = tabId;
      this.applyFilters();
    },
    weekKeyFromFdate(fdate) {
      if (!fdate || typeof fdate !== 'string') return fdate;
      const mWeek = fdate.match(/W(\d{1,2})/i);
      if (mWeek) return 'W' + mWeek[1].padStart(2, '0');
      const mDay = fdate.match(/D(\d+)/i);
      if (mDay) return 'D' + mDay[1].padStart(3, '0');
      return fdate;
    },
    /** Ordena statsDate por día (D002…) o por semana (W07…). */
    sortStatsDateByWeek(statsDateArray) {
      if (!Array.isArray(statsDateArray)) return;
      statsDateArray.sort((a, b) => {
        const mDA = a.date.match(/^D(\d+)$/i);
        const mDB = b.date.match(/^D(\d+)$/i);
        if (mDA && mDB) {
          return parseInt(mDA[1], 10) - parseInt(mDB[1], 10);
        }
        const nA = parseInt((a.date.match(/^W(\d{1,2})/i) || [])[1], 10) || 0;
        const nB = parseInt((b.date.match(/^W(\d{1,2})/i) || [])[1], 10) || 0;
        if (nA || nB) return nA - nB;
        return String(a.date).localeCompare(String(b.date));
      });
    },
    buildTaskOutputTable(result, statsTypes, totalFieldName) {
      const statsClient = {};
      const statsDate = [];
      const client_id = 0;
      const client_name = "";
      const totalsByFdate = {};
      const totalSeries = result && result[totalFieldName];

      if (Array.isArray(totalSeries)) {
        totalSeries.forEach((row) => {
          const fdate = this.weekKeyFromFdate(row.fdate);
          totalsByFdate[fdate] = parseFloat(row.total) || 0;
          if (!statsDate.find((field) => field.date === fdate)) {
            statsDate.push({ date: fdate });
          }
        });
      }

      statsTypes.forEach((type) => {
        (result[type.id] || []).forEach((item) => {
          const fdate = this.weekKeyFromFdate(item.fdate);

          if (!statsDate.find((field) => field.date === fdate)) {
            statsDate.push({ date: fdate });
          }

          if (statsClient[client_id] == undefined) {
            statsClient[client_id] = {};
            statsClient[client_id]["name"] = client_name;
          }
          if (statsClient[client_id][fdate] == undefined) {
            statsClient[client_id][fdate] = {};
          }
          const y = statsClient[client_id][fdate];
          const qty = parseFloat(item.total);
          const denom =
            totalsByFdate[fdate] != null ? totalsByFdate[fdate] : 0;
          y[type.id + "_qty"] = qty;
          y[type.id] =
            denom > 0
              ? ((qty / denom) * 100).toFixed(0) + " %"
              : "0 %";
          statsClient[client_id][fdate] = y;
        });
      });

      this.sortStatsDateByWeek(statsDate);
      return { statsClient, statsDate };
    },
    getCountries() {
      this.countriesLoading = true;
      bookersService.getRecruiterCountries()
        .then((response) => {
          this.countryOptions = response.result || response;
          this.countriesLoading = false;
        })
        .catch((error) => {
          console.error("Error loading countries:", error);
          this.countriesLoading = false;
        });
    },
    getRecruiters() {
      this.recruitersLoading = true;
      usersService.getBookerRecruiters()
        .then((response) => {
          const recruiters = response.result || response;
          this.recruiterOptions = recruiters.map(recruiter => ({
            id: recruiter.id,
            label: recruiter.name
          }));
          this.recruitersLoading = false;
        })
        .catch((error) => {
          console.error("Error loading recruiters:", error);
          this.recruitersLoading = false;
        });
    },
    applyFilters(period = null) {
      if(period != null){
        this.periodMetrics = period;
      }else{
        this.periodMetrics = null;
      }
      this.loading = true;
      if(this.tabSelected == 1){
        Promise.all([
           this.getData(),
           this.getDataTask('turnover'),
           this.getDataTask('onboarding'),
           this.getDataTask('validated'),
        ]).finally(() => {
          this.loading = false;
        });
      }else if(this.tabSelected == 2){
        Promise.all([
          this.getDataTask('cold_tasks_bookers'),
          this.getDataTask('warm_tasks_bookers'),
          this.getDataTask('meeting_attendance'),
          this.getDataTask('fake_meeting'),
        ]).finally(() => {
          this.loading = false;
        });
      }else if(this.tabSelected == 3){
        Promise.all([
          this.getDataTask('booker_manager_payments'),
          this.getDataTask('booker_non_manager_payments'),
        ]).finally(() => {
          this.loading = false;
        });
      }
      else if(this.tabSelected == 4){
        Promise.all([
          this.getDataTask('booker_calls_output'),
          this.getDataTask('ai_objections_analysis'),
          this.getDataTask('ai_email_answers_analysis'),
        ]).finally(() => {
          this.loading = false;
        });
      }
    },
    getData() {
      this.filters.typeTable = null;
      this.filters.yearFilter = this.filters.yearFilter == null ? new Date().getFullYear() : this.filters.yearFilter;
      this.filters.period = this.periodMetrics != null ? this.periodMetrics : null;
      return bookersService.getBookerPipeStats(this.filters).then((response) => {
        if (response.status == 200) {
          // Reset data structures before loading new filtered data
          this.statsClient = {};
          this.statsDate = [];
          const totalsstatus = response.result.totals_by_status || {};

          this.statsType.forEach((type) => {
            (totalsstatus[type.id] || []).forEach((item) => {
              const client_id = 0;
              const client_name = "";
              const fdate = this.weekKeyFromFdate(item.fdate);

              if (!this.statsDate.find((field) => field.date === fdate)) {
                this.statsDate.push({ date: fdate });
              }

              if (this.statsClient[client_id] == undefined) {
                this.statsClient[client_id] = {};
                this.statsClient[client_id]["name"] = client_name;
              }
              if (this.statsClient[client_id][fdate] == undefined) {
                this.statsClient[client_id][fdate] = {};
              }
              let y = this.statsClient[client_id][fdate];
              y[type.id + "_qty"] = parseFloat(item["total"]);
              if (type.id != "account_created") {
		            if(type.id == "interviewed"){
                  y[type.id] =
                  ((parseFloat(item["total"]) / y.account_created_qty) * 100).toFixed(0)  + ' %';
                  this.step_previous = "interviewed"; //PRIMERA VUELTA PASO ANTERIOR PRIMERO
                }else{
                  //console.log(y[this.step_previous + "_qty"])
                  y[type.id] =
                  ((parseFloat(item["total"]) / y[this.step_previous + "_qty"]) * 100).toFixed(0)  + ' %'; // LA DIVISION ES SOBRE LA SUMA DEL PASO ANTERIOR
                }
              }
              this.statsClient[client_id][fdate] = y;
            });
            this.step_previous = type.id; //RESTO DE VUELTAS INTERCALO LOS PASOS
          });
          this.sortStatsDateByWeek(this.statsDate);
        }
      });
    },

    getDataTask(tableType = null) {
      this.filters.typeTable = tableType;
      this.filters.period = this.periodMetrics != null ? this.periodMetrics : null;
      return bookersService.getBookerPipeStats(this.filters).then((response) => {
        if (response.status == 200) {
          switch (tableType) {
            case 'turnover':
              this.statsClientTask = {}; 
              this.statsDateTask = [];
              const totalsStatus = response.result.totals_by_status || {};

              this.statsTypeTask.forEach((type) => {
                (totalsStatus[type.id] || []).forEach((item) => {
                  const client_id = 0;
                  const client_name = "";
                  const fdate = this.weekKeyFromFdate(item.fdate);

                  if (!this.statsDateTask.find((field) => field.date === fdate)) {
                    this.statsDateTask.push({ date: fdate });
                  }

                  if (this.statsClientTask[client_id] == undefined) {
                    this.statsClientTask[client_id] = {};
                    this.statsClientTask[client_id]["name"] = client_name;
                  }
                  if (this.statsClientTask[client_id][fdate] == undefined) {
                    this.statsClientTask[client_id][fdate] = {};
                  }
                  let y = this.statsClientTask[client_id][fdate];
                  y[type.id + "_qty"] = parseFloat(item["total"]);
                  if (type.id != "tasks") {
                    if(type.id == "booker_stopped"){
                      y[type.id] =
                      ((parseFloat(item["total"]) / y.tasks_qty) * 100).toFixed(0)  + ' %';
                      this.step_previous = "booker_stopped"; 
                    }
                  }
                  this.statsClientTask[client_id][fdate] = y;
                });
                this.step_previous = type.id; 
              });
              this.sortStatsDateByWeek(this.statsDateTask);
              break;
            case 'onboarding':

              this.statsClientOnboarding = {}; 
              this.statsDateOnboarding = [];
              const totalsDays = response.result.totals_by_avg_days || {};
              
              this.statsTypeOnboarding.forEach((type) => {
                (totalsDays[type.id] || []).forEach((item) => {
                  const client_id = 0;
                  const client_name = "";
                  const fdate = this.weekKeyFromFdate(item.fdate);

                  if (!this.statsDateOnboarding.find((field) => field.date === fdate)) {
                    this.statsDateOnboarding.push({ date: fdate });
                  }

                  if (this.statsClientOnboarding[client_id] == undefined) {
                    this.statsClientOnboarding[client_id] = {};
                    this.statsClientOnboarding[client_id]["name"] = client_name;
                  }
                  if (this.statsClientOnboarding[client_id][fdate] == undefined) {
                    this.statsClientOnboarding[client_id][fdate] = {};
                  }
                  let y = this.statsClientOnboarding[client_id][fdate];
                  y[type.id + "_qty"] = parseFloat(item["total"]);
                  // if (type.id != "tasks") {
                  //   if(type.id == "booker_stopped"){
                  //     y[type.id] =
                  //     ((parseFloat(item["total"]) / y.tasks_qty) * 100).toFixed(0)  + ' %';
                  //     this.step_previous = "booker_stopped"; 
                  //   }
                  // }
                  this.statsClientOnboarding[client_id][fdate] = y;
                });
                this.step_previous = type.id; 
              });
              this.sortStatsDateByWeek(this.statsDateOnboarding);
              break;
              
              case 'warm_tasks_bookers':

                this.statsClientWarmTasksBookers = {}; 
                this.statsDateWarmTasksBookers = [];
                const totalsWarmTasks = response.result.warm_tasks_stats;

                this.statsTypeWarmTasksBookers.forEach((type) => {
                  totalsWarmTasks[type.id].forEach((item) => {
                    const client_id = 0;
                    const client_name = "";
                    const fdate = this.weekKeyFromFdate(item.fdate);

                    if (!this.statsDateWarmTasksBookers.find((field) => field.date == fdate)) {
                      this.statsDateWarmTasksBookers.push({ date: fdate });
                    }

                    if (this.statsClientWarmTasksBookers[client_id] == undefined) {
                      this.statsClientWarmTasksBookers[client_id] = {};
                      this.statsClientWarmTasksBookers[client_id]["name"] = client_name;
                    }
                    if (this.statsClientWarmTasksBookers[client_id][fdate] == undefined) {
                      this.statsClientWarmTasksBookers[client_id][fdate] = {};
                    }
                    let y = this.statsClientWarmTasksBookers[client_id][fdate];
                    if (type.id == "conversion_rate") {
                      y[type.id + "_rate"] = parseFloat(item["total"]);
                    } else {
                      y[type.id + "_qty"] = parseFloat(item["total"]);
                    }
                    this.statsClientWarmTasksBookers[client_id][fdate] = y;
                  });
                  this.step_previous = type.id; 
                });
                this.sortStatsDateByWeek(this.statsDateWarmTasksBookers);
                break;
              case 'meeting_attendance':

                  this.statsClientMeetingAttendance = {}; 
                  this.statsDateMeetingAttendance = [];
                  const totalsMeetingAttendance = response.result.meeting_attendance_stats;

                  this.statsTypeMeetingAttendance.forEach((type) => {
                    totalsMeetingAttendance[type.id].forEach((item) => {
                      const client_id = 0;
                      const client_name = "";
                      const fdate = this.weekKeyFromFdate(item.fdate);

                      if (!this.statsDateMeetingAttendance.find((field) => field.date == fdate)) {
                        this.statsDateMeetingAttendance.push({ date: fdate });
                      }

                      if (this.statsClientMeetingAttendance[client_id] == undefined) {
                        this.statsClientMeetingAttendance[client_id] = {};
                        this.statsClientMeetingAttendance[client_id]["name"] = client_name;
                      }
                      if (this.statsClientMeetingAttendance[client_id][fdate] == undefined) {
                        this.statsClientMeetingAttendance[client_id][fdate] = {};
                      }
                      let y = this.statsClientMeetingAttendance[client_id][fdate];
                      if (type.id == "rate_meeting_valid" || type.id == "total_cancelled_meeting" || type.id == "total_unable_to_reach") {
                        y[type.id + "_rate"] = parseFloat(item["total"]);
                      } else {
                        y[type.id + "_qty"] = parseFloat(item["total"]);
                      }
                      this.statsClientMeetingAttendance[client_id][fdate] = y;
                    });
                    this.step_previous = type.id; 
                  });
                  this.sortStatsDateByWeek(this.statsDateMeetingAttendance);
                  break;

              case 'fake_meeting':

                  this.statsClientFakeMeeting = {}; 
                  this.statsDateFakeMeeting = [];
                  const totalsFakeMeeting = response.result.fake_meetings_stats;

                  this.statsTypeFakeMeeting.forEach((type) => {
                    totalsFakeMeeting[type.id].forEach((item) => {
                      const client_id = 0;
                      const client_name = "";
                      const fdate = this.weekKeyFromFdate(item.fdate);

                      if (!this.statsDateFakeMeeting.find((field) => field.date == fdate)) {
                        this.statsDateFakeMeeting.push({ date: fdate });
                      }

                      if (this.statsClientFakeMeeting[client_id] == undefined) {
                        this.statsClientFakeMeeting[client_id] = {};
                        this.statsClientFakeMeeting[client_id]["name"] = client_name;
                      }
                      if (this.statsClientFakeMeeting[client_id][fdate] == undefined) {
                        this.statsClientFakeMeeting[client_id][fdate] = {};
                      }
                      let y = this.statsClientFakeMeeting[client_id][fdate];
                      if (type.id == "total_fake") {
                        y[type.id + "_rate"] = parseFloat(item["total"]);
                      } else {
                        y[type.id + "_qty"] = parseFloat(item["total"]);
                      }
                      this.statsClientFakeMeeting[client_id][fdate] = y;
                    });
                    this.step_previous = type.id; 
                  });
                  this.sortStatsDateByWeek(this.statsDateFakeMeeting);
                  break;

              case 'booker_manager_payments':

                  this.statsClientBookerManagerPayments = {}; 
                  this.statsDateBookerManagerPayments = [];
                  const totalsBookerManagerPayments = response.result.booker_manager_payments_stats;

                  this.statsTypeBookerManagerPayments.forEach((type) => {
                    totalsBookerManagerPayments[type.id].forEach((item) => {
                      const client_id = 0;
                      const client_name = "";
                      const fdate = item.fdate.replace(/-/g, "/");

                      if (!this.statsDateBookerManagerPayments.find((field) => field.date == fdate)) {
                        this.statsDateBookerManagerPayments.push({ date: fdate });
                      }

                      if (this.statsClientBookerManagerPayments[client_id] == undefined) {
                        this.statsClientBookerManagerPayments[client_id] = {};
                        this.statsClientBookerManagerPayments[client_id]["name"] = client_name;
                      }
                      if (this.statsClientBookerManagerPayments[client_id][fdate] == undefined) {
                        this.statsClientBookerManagerPayments[client_id][fdate] = {};
                      }
                      let y = this.statsClientBookerManagerPayments[client_id][fdate];
                      y[type.id + "_qty"] = parseFloat(item["total"]);
                      this.statsClientBookerManagerPayments[client_id][fdate] = y;
                    });
                    this.step_previous = type.id; 
                  });
                  break;

              case 'booker_non_manager_payments':

                  this.statsClientBookerColdCallersPayments = {}; 
                  this.statsDateBookerColdCallersPayments = [];
                  const totalsBookerColdCallersPayments = response.result.booker_non_manager_payments_stats;

                  this.statsTypeBookerColdCallersPayments.forEach((type) => {
                    totalsBookerColdCallersPayments[type.id].forEach((item) => {
                      const client_id = 0;
                      const client_name = "";
                      const fdate = item.fdate.replace(/-/g, "/");

                      if (!this.statsDateBookerColdCallersPayments.find((field) => field.date == fdate)) {
                        this.statsDateBookerColdCallersPayments.push({ date: fdate });
                      }

                      if (this.statsClientBookerColdCallersPayments[client_id] == undefined) {
                        this.statsClientBookerColdCallersPayments[client_id] = {};
                        this.statsClientBookerColdCallersPayments[client_id]["name"] = client_name;
                      }
                      if (this.statsClientBookerColdCallersPayments[client_id][fdate] == undefined) {
                        this.statsClientBookerColdCallersPayments[client_id][fdate] = {};
                      }
                      let y = this.statsClientBookerColdCallersPayments[client_id][fdate];
                      y[type.id + "_qty"] = parseFloat(item["total"]);
                      this.statsClientBookerColdCallersPayments[client_id][fdate] = y;
                    });
                    this.step_previous = type.id; 
                  });
                  break;                  
            case 'cold_tasks_bookers':

                this.statsClientColdTasksBookers = {}; 
                this.statsDateColdTasksBookers = [];
                const totalsColdTasks = response.result.cold_tasks_stats;

                this.statsTypeColdTasksBookers.forEach((type) => {
                  totalsColdTasks[type.id].forEach((item) => {
                    const client_id = 0;
                    const client_name = "";
                    const fdate = this.weekKeyFromFdate(item.fdate);

                    if (!this.statsDateColdTasksBookers.find((field) => field.date == fdate)) {
                      this.statsDateColdTasksBookers.push({ date: fdate });
                    }

                    if (this.statsClientColdTasksBookers[client_id] == undefined) {
                      this.statsClientColdTasksBookers[client_id] = {};
                      this.statsClientColdTasksBookers[client_id]["name"] = client_name;
                    }
                    if (this.statsClientColdTasksBookers[client_id][fdate] == undefined) {
                      this.statsClientColdTasksBookers[client_id][fdate] = {};
                    }
                    let y = this.statsClientColdTasksBookers[client_id][fdate];
                    
                    if (type.id == "conversion_rate") {
                      y[type.id + "_rate"] = parseFloat(item["total"]);
                    } else {
                      y[type.id + "_qty"] = parseFloat(item["total"]);
                    }
                    this.statsClientColdTasksBookers[client_id][fdate] = y;
                  });
                  this.step_previous = type.id; 
                });
                this.sortStatsDateByWeek(this.statsDateColdTasksBookers);
                break;
            case 'validated':

                this.statsClientValidated = {}; 
                this.statsDateValidated = [];
                const totalsDaysValidated = response.result.totals_by_avg_days_validated || {};

                this.statsTypeValidated.forEach((type) => {
                  (totalsDaysValidated[type.id] || []).forEach((item) => {
                    const client_id = 0;
                    const client_name = "";
                    const fdate = this.weekKeyFromFdate(item.fdate);

                    if (!this.statsDateValidated.find((field) => field.date === fdate)) {
                      this.statsDateValidated.push({ date: fdate });
                    }

                    if (this.statsClientValidated[client_id] == undefined) {
                      this.statsClientValidated[client_id] = {};
                      this.statsClientValidated[client_id]["name"] = client_name;
                    }
                    if (this.statsClientValidated[client_id][fdate] == undefined) {
                      this.statsClientValidated[client_id][fdate] = {};
                    }
                    let y = this.statsClientValidated[client_id][fdate];
                    y[type.id + "_qty"] = parseFloat(item["total"]);
                    // if (type.id != "tasks") {
                    //   if(type.id == "booker_stopped"){
                    //     y[type.id] =
                    //     ((parseFloat(item["total"]) / y.tasks_qty) * 100).toFixed(0)  + ' %';
                    //     this.step_previous = "booker_stopped"; 
                    //   }
                    // }
                    this.statsClientValidated[client_id][fdate] = y;
                  });
                  this.step_previous = type.id; 
                });
                this.sortStatsDateByWeek(this.statsDateValidated);
                break;
            case "booker_calls_output": {
              const r = response.result || {};
              const built = this.buildTaskOutputTable(
                r,
                this.statsTypeBookerCallsOutput,
                "total_calls"
              );
              this.statsClientBookerCallsOutput = built.statsClient;
              this.statsDateBookerCallsOutput = built.statsDate;
              break;
            }
            case "ai_objections_analysis": {
              const r = response.result || {};
              const built = this.buildTaskOutputTable(
                r,
                this.statsTypeAiObjectionsAnalysis,
                "total_transcription_ai_result"
              );
              this.statsClientAiObjectionsAnalysis = built.statsClient;
              this.statsDateAiObjectionsAnalysis = built.statsDate;
              break;
            }
            case "ai_email_answers_analysis": {
              const r = response.result || {};
              const built = this.buildTaskOutputTable(
                r,
                this.statsTypeAiEmailAnswersAnalysis,
                "total_sent"
              );
              this.statsClientAiEmailAnswersAnalysis = built.statsClient;
              this.statsDateAiEmailAnswersAnalysis = built.statsDate;
              break;
            }
            default:
              break;
          }
        }
      });
    },
  },
};
</script>

<style scoped>
/* Anula el min-height global de .table-responsive (450px) que genera mucho espacio entre tablas */
.recruitments-tab :deep(.table-responsive) {
  min-height: 150px;
}
</style>
